import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { FaXTwitter, FaLinkedinIn, FaInstagram, FaFacebookF } from "react-icons/fa6";
import Logo from "@/components/layout/Logo";

const cols = [
  {
    title: "Services",
    items: [
      ["Shopify Store Design", "/services"],
      ["CRO Optimization", "/services"],
      ["Meta Ads Management", "/services"],
      ["Google Ads Management", "/services"],
      ["Speed Optimization", "/services"],
      ["Funnel Building", "/services"],
    ],
  },
  {
    title: "Company",
    items: [
      ["About", "/about"],
      ["Case Studies", "/case-studies"],
      ["Portfolio", "/portfolio"],
      ["Blog", "/blog"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Legal",
    items: [
      ["Privacy Policy", "/privacy"],
      ["Terms & Conditions", "/terms"],
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/5 bg-kavion-bg overflow-hidden">
      <div className="orb -top-40 -left-40 w-[480px] h-[480px] bg-indigo-700/30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size="large" />
            <p className="mt-6 text-zinc-400 max-w-md font-body leading-relaxed">
              Kavion Global Limited is a premium eCommerce growth partner helping D2C brands
              scale profitably with CRO-optimized Shopify stores and high-performance ad systems.
            </p>
            <div className="mt-8 space-y-3 text-sm text-zinc-400">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" />
                <span data-testid="footer-address">
                  UNIT 2904-05, 29/F Universal Trade Ctr,<br />
                  3 Arbuthnot Rd, Central, Hong Kong
                </span>
              </div>
              <a
                href="mailto:info@kavionglobal.com"
                data-testid="footer-email"
                className="flex items-center gap-3 hover:text-white transition"
              >
                <Mail className="h-4 w-4 text-blue-400" />
                info@kavionglobal.com
              </a>
            </div>
            <div className="mt-8 flex gap-3">
              {[
                { Icon: FaLinkedinIn, label: "linkedin" },
                { Icon: FaXTwitter, label: "twitter" },
                { Icon: FaInstagram, label: "instagram" },
                { Icon: FaFacebookF, label: "facebook" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`footer-social-${label}`}
                  className="h-10 w-10 grid place-items-center rounded-full glass hover:bg-white/10 transition"
                  aria-label={label}
                >
                  <Icon className="h-4 w-4 text-zinc-300" />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold mb-5">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.items.map(([label, to]) => (
                  <li key={label}>
                    <Link
                      to={to}
                      className="text-sm text-zinc-400 hover:text-white transition inline-flex items-center gap-1 group"
                    >
                      {label}
                      <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 hidden md:block" />
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Kavion Global Limited. All rights reserved.
          </p>
          <p className="text-xs text-zinc-500">
            Crafted in Hong Kong • Serving global D2C brands
          </p>
        </div>
      </div>
    </footer>
  );
}
